import React from 'react'
import * as S from '../../styles'

export const FifthRowWidgets = ({
  devicePolicyAccessState,
  usersAccessState,
  solutionsAccessState,
  renderSolutionsWidget
}) => {
  const renderFifthRow = () => {
    // Render the Solutions widget only if solutions access is true
    // and devicePolicyAccessState and usersAccessState are both true,
    // or both are false
    if (solutionsAccessState && devicePolicyAccessState === usersAccessState) {
      return (
        <S.Grid
          leftChildFrWidth={6}
          rightChildFrWidth={6}
        >
          {renderSolutionsWidget}
        </S.Grid>
      )
    }
  }

  return <>{renderFifthRow()}</>
}

export default FifthRowWidgets
